var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (item) {
var hasCount = !(item.count === undefined)
buf.push("<a" + (jade.cls(['js-partner-filter','partner-search-filter-item',(hasCount && item.count <= 0 ? 'is-disabled' : '')], [null,null,true])) + ">" + (jade.escape(null == (jade_interp = item.name + ( hasCount ? ' (' + item.count + ')' : '' )) ? "" : jade_interp)) + "</a>");}.call(this,"item" in locals_for_with?locals_for_with.item:typeof item!=="undefined"?item:undefined));;return buf.join("");
};
module.exports = template;